/// <reference path="../../_ext/editors/ItemGridEditor.ts" />

namespace TabAurous.Finance {
    import fld = PartyBalanceRow.Fields;
    @Serenity.Decorators.registerClass()
    export class PartyBalanceEditor extends _Ext.GridEditorBase<PartyBalanceRow> {
        protected getColumnsKey() { return "Finance.PartyBalance"; }
        protected getDialogType() { return PartyBalanceDialog; }
        protected getLocalTextPrefix() { return PartyBalanceRow.localTextPrefix; }
        public pendingChanges: Q.Dictionary<any> = {};   
        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            this.view.onDataChanged.subscribe(() => {
                if (this.view.getItems().length > 0) {
                    (this.parentDialog as any).calculatePartyBalance();
                }
            })
        }
        protected getButtons(): Serenity.ToolButton[] {//remove add button from editor
            var buttons = super.getButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            return buttons;
        }
        //function to set partybalance grid from ledger id
        public setPartyBalance(ledgerId:number) {
            let balance;//to save party balance
            this.clearGrid();
            //service to call database to fetch details
            PartyBalanceService.GetPartyBalance({
                LedgerId: ledgerId, CompanyId:Q.Authorization.userDefinition.CompanyId,
                    FinancialYearId: Q.Authorization.userDefinition.FinancialYearId, 
            },
                response =>
                    balance = response,
                { async: false });

            for (let pbalance of balance.Entities) {
                pbalance[this.getIdProperty()] = "`" + this.nextId++;
                var x = pbalance; 
                this.view.addItem(x);
            }
            
        }
        public setCustomerBalance(ledgerId) {
            let balance;//to save party balance
            this.clearGrid();
            //service to call database to fetch details
            PartyBalanceService.CustomerBalanceList({
                POSCustomerId: parseInt(ledgerId)
            },
                response =>
                    balance = response,
                { async: false });

            for (let pbalance of balance.Entities) {
                pbalance[this.getIdProperty()] = "`" + this.nextId++;
                var x = pbalance; 
                this.view.addItem(x);
            }

        }
        public clearGrid() {
            var item = [];
            this.view.setItems(item, true);
        }
        setCustomerRefund(refunds: PartyBalanceRow[]) {
            for (let pbalance of refunds ) {
                pbalance[this.getIdProperty()] = "`" + this.nextId++;
                var x = pbalance; 
                this.view.addItem(x);
            }

        }
        //add the knock off edit column
        public getColumns() {

            var columns = super.getColumns();
            var num = ctx => ColumnFormatter.AmountFormatter(ctx, this);

            Q.first(columns, x => x.field === fld.KnockOff).format = num;

            this.view.refresh();
            return columns;
        }

        //validate knock off value
        private inputsChange(e: JQueryEventObject) {
            var cell = this.slickGrid.getCellFromEvent(e);
            var item = this.itemAt(cell.row);
            var input = $(e.target);
            var field = input.data('field');
            var text = Q.coalesce(Q.trimToNull(input.val()), '0');
            var id = this.id(item);
            var pending = this.pendingChanges[id];

            var effective = this.getEffectiveValue(item, field);
            var oldText: string = input.hasClass('numeric')
                ? Q.formatNumber(effective, '0.00')
                : effective as string;

            var value;
            if (field === fld.KnockOff) {
                value = Q.parseDecimal(text);
                if (value == null || isNaN(value)) {
                    Q.notifyError(Q.text('Validation.Decimal'), '', null);
                    input.val(oldText);
                    input.focus();
                    return;
                }
            }
            else {
                value = text;
            }
            if (field === fld.KnockOff && value >= 0) {
                //to check the new entered value is not greater than the total amount
               
                var Knockoffvalue = parseFloat(value);
                var knockoffdone = (this.parentDialog as any).form.KnockOffTotal.value - item.KnockOff;

                var knockoffpossible = (this.parentDialog as any).form.TotalAmount.value;
                if ((knockoffdone + Knockoffvalue) > knockoffpossible) {
                    item.Due = item.TotalAmount - 0;
                    item[field] = 0;  
                    this.view.updateItem(id, item);
                    this.view.refresh();
                    Q.alert('Knock off value should be less than Total Amount');
                    return;
                } 
                if (item.TotalAmount >= Knockoffvalue) {
                    if (value <= item.Due) {
                        item.Due = item.TotalAmount - value;
                        item[field] = value;
                    }
                } else {
                    Q.alert('Knock off value should be less than Total Amount'); 
                    return;
                }

            }
            (this.parentDialog as any).calculatePartyBalance();
            this.view.updateItem(id, item);
            this.view.refresh();

            if (input.hasClass('numeric'))
                value = Q.formatNumber(value, '0.00');

            if (input.hasClass('integer'))
                value = Q.formatNumber(value, '0');

            input.val(value).addClass('dirty');
        }


        private getEffectiveValue(item, field: any): any {
            var id = this.id(item);
            var pending = this.pendingChanges[id];
            if (pending && pending[field] !== undefined) {
                return pending[field];
            }

            return item[field];
        }
        protected onViewProcessData(response) {
            this.pendingChanges = {};
            return super.onViewProcessData(response);
        }


        // **** validate the party balance grid
        // To check if the Knock-off value can be changed or not depending on if the voucher no. has any further payments made
        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell); 
            var item = this.itemAt(row);
            var target = $(e.target);
            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('edit numeric'))
                target = target.parent();

            if (target.hasClass('edit numeric')) {
                e.preventDefault();

                if (target.hasClass('edit numeric')) {
                    // var x = Q.coalesce(Q.trimToNull(input.val()), '0');
                    //TODO: Need to add System Parameter to enable disable blocking
                    var input = $(e.target);
                    if (input != undefined) {
                        let values;
                        
                        var input = $(e.target);
                        let oldvalue: PartyBalanceRow;
                        PartyBalanceService.ValidatePartyBalance({ VoucherNo: item.VoucherNo },
                            response => {
                                oldvalue= response.Entity
                            },
                            { async: false });
                        if (oldvalue.PartyBalanceId > item.PartyBalanceId) {
                            target.addClass('readonly');
                            target.blur(); 
                            Q.alert("Further Payments for this voucher have been made due to which it cannot be edited");
                            return;
                        }
                        //var x = Q.coalesce(Q.trimToNull(input.val()), '0');
                        //if (x != "0" && this.editMode) {
                        //    //fetch the old knock off values 
                        //    if (item.AgainstVoucherTypeId == 5) {
                        //        ReceiptService.KnockOffvalues({}, response =>
                        //            values = response,
                        //            { async: false });
                        //    }
                        //    else {
                        //        PaymentService.KnockOffvalues({}, response =>
                        //            values = response,
                        //            { async: false });
                        //    }
                            

                        //    var condition = false;
                        //    for (let a of values) {
                        //        if (a == x) {

                        //            target.addClass('readonly');
                        //            target.blur();
                        //            condition = true;
                        //            Q.alert("Further Payments for this voucher have been made due to which it cannot be edited")
                        //        }
                        //    } 
                        //}
                    }
                   
                    this.view.refresh();
                }
            }
        }


    }
}